import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/closet-insights-poshmark';

export default function Example() {
  return (
    <>
      <Head>
        <title>Everything You Need to Know About Poshmrk's Closet Insights</title>
        <meta
          name='description'
          content='Poshmark allows you to manage your closet from anywhere you have an internet connection. In this blog, we have listed some simple tips for you to get the most out of Poshmark.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/closet-insights-poshmark' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/closet-insights-poshmark' />
        <meta property='og:title' content="Everything You Need to Know About Poshmrk's Closet Insights" />
        <meta
          property='og:description'
          content='Poshmark allows you to manage your closet from anywhere you have an internet connection. In this blog, we have listed some simple tips for you to get the most out of Poshmark.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
